import { z } from 'zod';

export const CreateWorkerTransitionRequest = z.object({
  worker_user_id: z.string().min(1).max(40),
  role_key: z
    .string()
    .regex(/^[a-z0-9_]+$/)
    .max(80),
  chain_family: z.enum(['pool_filter', 'restaurant_booking', 'guest_preparation', 'other']),
  baseline_days: z.number().int().positive().max(365).optional(),
  consent_confirmed: z.literal(true),
});

export const WorkerTransitionMilestoneRequest = z.object({
  milestone: z.enum(['first_shift_started', 'first_chain_completed', 'baseline_reached']),
  owner_interventions: z.number().int().min(0).max(100),
  outcome_accepted: z.boolean(),
  note: z.string().max(500).optional(),
});

export const WorkerTransitionReviewRequest = z.object({
  review_kind: z.enum(['missing_knowledge', 'inappropriate_disclosure']),
  memory_entry_id: z.string().max(40).optional(),
  detail: z.string().min(1).max(1000),
});

export type CreateWorkerTransition = z.infer<typeof CreateWorkerTransitionRequest>;
export type WorkerTransitionMilestoneInput = z.infer<typeof WorkerTransitionMilestoneRequest>;
export type WorkerTransitionReviewInput = z.infer<typeof WorkerTransitionReviewRequest>;
